/**
 * Csv Schema of BaseFretebasEmpresa
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {BaseFretebasEmpresa} from '@/model/resource/BaseFretebasEmpresa'

/* TODO: review generated schema */
export class CsvBaseFretebasEmpresaSchema extends Schema {
  readonly name = 'CsvBaseFretebasEmpresa'

  readonly fieldSet: FieldSet<BaseFretebasEmpresa> = {
    idFretebasPk: schema => schema.model.idFretebasPk,
    empresa: schema => schema.model.empresa,
    razaoSocial: schema => schema.model.razaoSocial,
    ramo: schema => schema.model.ramo,
    tipo: schema => schema.model.tipo,
    endereco: schema => schema.model.endereco,
    nextel: schema => schema.model.nextel,
    celular: schema => Helper.phone(schema.model.celular),
    fone: schema => Helper.phone(schema.model.fone),
    whatsup: schema => schema.model.whatsup,
    sac: schema => schema.model.sac,
    response: schema => schema.model.response,
  }
}
